import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Card, Col, Container, Row} from 'react-bootstrap';
import DefaultLayout from '../../components/Layout/DefaultLayout';
import {useDashboardStats} from '../../hooks/api/dashboard';
import {STAT_GROUPS} from '../../constants/statGroups';
import {formatAmount} from '../../utils/format';
import AlertCenter from './components/AlertCenter';

const Dashboard = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {stats, loading} = useDashboardStats();

    const handleTileClick = (group) => {
        const params = new URLSearchParams();
        if (stats.scopedCustomerIds && stats.scopedCustomerIds.length > 0) {
            params.set('customerId', stats.scopedCustomerIds.join(','));
        }
        params.set('status', group.statuses.join(','));
        navigate(`/tiers-payant?${params.toString()}`);
    };

    return (
        <DefaultLayout>
            <Container fluid className="py-4">
                <h2 className="mb-4">{t('dashboard.title')}</h2>
                {loading || !stats.counts ? (
                    <p>{t('dashboard.loading')}</p>
                ) : (
                    <>
                        <Row>
                            {STAT_GROUPS.map((group) => {
                                const textCol = group.textColor === 'dark' ? '#212529' : '#fff';
                                return (
                                    <Col md={6} lg={4} className="mb-3" key={group.key}>
                                        <Card
                                            bg={group.color}
                                            role="button"
                                            onClick={() => handleTileClick(group)}
                                            style={{cursor: 'pointer'}}
                                        >
                                            <Card.Body style={{color: textCol}}>
                                                <Card.Title style={{color: textCol}}>{t(`dashboard.tile.${group.key}`)}</Card.Title>
                                                <h1 className="display-4 mb-0" style={{color: textCol}}>
                                                    {stats.counts[group.key] ?? 0}
                                                </h1>
                                                <div className="h3 mb-0 fw-bold" style={{color: textCol, opacity: 0.95}}>
                                                    {formatAmount(stats.amounts?.[group.key])}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                        <AlertCenter stats={stats} />
                    </>
                )}
            </Container>
        </DefaultLayout>
    );
};

export default Dashboard;
